import { Component, Input } from '@angular/core';

@Component({
  selector: 'belender-widget-step-logo',
  template: `
    <belender-widget-logo
      [firstOption]="customImage"
      [withLogo]="withLogo ?? data?.styles?.withLogo"
      [logoUrl]="data?.styles?.logoUrl">
    </belender-widget-logo>
  `
})
export class WidgetStepLogoComponent {
  @Input() data: any;
  @Input() customImage?: string;
  @Input() withLogo?: boolean;
}
